import React from 'react';
import { Section } from '../ui/Section';
import { User, Award, Users, Leaf, Zap } from 'lucide-react';
import { Button } from '../ui/Button';
export function AuthorSection() {
  return <Section className="bg-brand-card/50 border-y border-white/5" data-id="element-12">
      <div className="max-w-4xl mx-auto" data-id="element-13">
        <div className="flex flex-col md:flex-row gap-10 items-center md:items-start" data-id="element-14">
          <div className="flex-shrink-0" data-id="element-15">
            <div className="w-40 h-40 rounded-full bg-gradient-to-br from-brand-gold to-brand-dark p-1" data-id="element-16">
              <div className="w-full h-full rounded-full bg-brand-card flex items-center justify-center border-4 border-brand-dark" data-id="element-17">
                <User className="w-20 h-20 text-brand-gold/50" data-id="element-18" />
              </div>
            </div>
          </div>

          <div data-id="element-19">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-2" data-id="element-20">
              Conoce a David Miller
            </h2>
            <p className="text-brand-gold font-semibold tracking-wide uppercase text-sm mb-6" data-id="element-21">
              Coach Sexual de Élite • Ingeniero de la Virilidad Natural
            </p>

            <div className="space-y-4 text-gray-300 text-lg mb-8" data-id="element-22">
              <p data-id="element-23">
                David no es un médico tradicional que te recetará químicos en
                forma de pastilla para disfrazar el síntoma y enviarte a casa.
                Él es un experto en la restauración de la virilidad natural
                mediante lo que llama{' '}
                <strong className="text-white" data-id="element-24">
                  "Ingeniería de la Virilidad"
                </strong>
                : un sistema de fácil aplicación, potenciado por alimentos
                estratégicos que ya tienes en tu alacena y que puedes integrar
                en tu dieta diaria.
              </p>
              <p data-id="element-25">
                Tras años de investigación sobre cómo el entorno moderno
                destruye la biología masculina, David desarrolló el protocolo
                exacto de este sistema. Lo encontrarás en El Manual Prohibido.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-26">
              <div className="bg-white/5 p-4 rounded-lg border border-white/10 text-center" data-id="element-27">
                <Users className="w-6 h-6 text-brand-gold mx-auto mb-2" data-id="element-28" />
                <p className="font-bold text-white text-xl" data-id="element-29">46,000+</p>
                <p className="text-xs text-brand-muted uppercase tracking-wider" data-id="element-30">
                  Hombres Transformados
                </p>
              </div>
              <div className="bg-white/5 p-4 rounded-lg border border-white/10 text-center" data-id="element-31">
                <Award className="w-6 h-6 text-brand-gold mx-auto mb-2" data-id="element-32" />
                <p className="font-bold text-white text-xl" data-id="element-33">15+ Años</p>
                <p className="text-xs text-brand-muted uppercase tracking-wider" data-id="element-34">
                  De Experiencia
                </p>
              </div>
              <div className="bg-white/5 p-4 rounded-lg border border-white/10 text-center" data-id="element-35">
                <Leaf className="w-6 h-6 text-brand-gold mx-auto mb-2" data-id="element-36" />
                <p className="font-bold text-white text-xl" data-id="element-37">100%</p>
                <p className="text-xs text-brand-muted uppercase tracking-wider" data-id="element-38">
                  Método Natural
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col items-center mt-12 gap-3" data-id="element-39">
          <Button className="w-full sm:w-auto group px-10" data-id="element-40">
            <span className="text-lg md:text-xl leading-tight text-center" data-id="element-41">
              EMPEZAR MI
              <br data-id="element-42" />
              TRANSFORMACIÓN NATURAL
            </span>
          </Button>
          <span className="text-sm text-brand-muted" data-id="element-43">
            Garantía de satisfacción total por 60 días.
          </span>
        </div>
      </div>
    </Section>;
}